import React from 'react';
import { useShallow } from 'zustand/react/shallow';

import { Button, Modal } from '@attentive-platform/stem-ui';
import { useRosettaStore } from '../../../Stores/useRosettaStore';

const ImageModal = () => {
  const { showImageModal, currentImages, currentImageIndex, dispatch } = useRosettaStore(
    useShallow(state => ({
      showImageModal: state.showImageModal,
      currentImages: state.currentImages,
      currentImageIndex: state.currentImageIndex,
      dispatch: state.dispatch
    }))
  );

  const closeImageModal = () => {
    dispatch({ type: 'SET_SHOW_IMAGE_MODAL', payload: false });
  };

  const nextImage = () => {
    dispatch({ type: 'NEXT_IMAGE' });
  };

  const previousImage = () => {
    dispatch({ type: 'PREVIOUS_IMAGE' });
  };

  if (!showImageModal || !currentImages || currentImages.length === 0) {
    return null;
  }

  return (
    <Modal
      show={showImageModal}
      onClose={closeImageModal}
      content={
        <div className='flex flex-col items-center gap-4 p-4'>
          <div className='flex items-center justify-between w-full'>
            <Button variant='outlined' onClick={previousImage} disabled={currentImageIndex === 0} size='small'>
              ❮ Previous
            </Button>
            <span className='text-sm font-medium'>
              {currentImageIndex + 1} / {currentImages.length}
            </span>
            <Button
              variant='outlined'
              onClick={nextImage}
              disabled={currentImageIndex === currentImages.length - 1}
              size='small'>
              Next ❯
            </Button>
          </div>
          <img
            className='max-w-full max-h-96 object-contain rounded-lg'
            src={currentImages[currentImageIndex]}
            alt={`${currentImageIndex + 1}`}
          />
        </div>
      }
    />
  );
};

export default ImageModal;
